import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { AnalysisCompany, CheckDuplicateAnalysisCompanyDto, CreateAnalysisCompanyDto } from 'models/AnalysisCompany';
import { AuthHttpClient } from './auth-http-client';

@autoinject
export class AnalysisCompanyService {
  constructor(
    private client: NetlogHttpClient,
    private httpClient: AuthHttpClient
  ) {}

  async getCompany(id: number) {
    return await this.client.get<AnalysisCompany>({
      url: `api/analysis-companies/${id}`,
      model: AnalysisCompany,
    });
  }

  async getCompanies() {
    return await this.client.get<AnalysisCompany[]>({
      url: `api/analysis-companies`,
      model: AnalysisCompany,
    });
  }

  async checkDuplicate(data: CheckDuplicateAnalysisCompanyDto) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`api/analysis-companies/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async createAnalysisCompany(dto: CreateAnalysisCompanyDto) {
    return await this.httpClient.exec<{ AnalysisCompanyId: number }>(`api/analysis-companies`, {
      method: 'POST',
      body: JSON.stringify(dto),
    });
  }
}
